<div class="overlay-mobile-backdrop" aria-hidden="true"></div>
<div
  class="overlay-mobile-sheet"
  [style.bottom]="nativeSafeZoneService.paddings.navbarHeight + 'px'"
  [style.max-height]="maxHeight"
>
  <div #scrollBody class="overlay-mobile-sheet--body" [ngStyle]="{'margin-top': customTopMargin}">
    <ng-content></ng-content>
  </div>
  <div class="overlay-mobile-sheet--footer">
    <ng-content select="[sheetFooter]"></ng-content>
  </div>
</div>
